import { RATES_PRICING_URL } from '@/constants';

import type { CmsPlanSchema } from '../../hooks/use-plans-cms';
import type { PlanSchema } from '@energy-retailer/schema';

export const getPlanDocsURL = ({
  docs,
}: PlanSchema | NonNullable<CmsPlanSchema>): string => {
  if (docs.length === 0) {
    return RATES_PRICING_URL as string;
  }

  if (docs.length === 1) {
    return docs[0].url;
  }

  // If we have multiple, this is a plan with combined controlled load.
  // Redirect to RATES_PRICING_URL with query params to display the selected docs.
  const planDocURLs = docs.map((doc) => doc.planID);

  return `${RATES_PRICING_URL}?planID=${planDocURLs.join(',')}`;
};
